import React, { useEffect, useState } from "react";
import { FaCopy, FaCheck, FaUsers } from "react-icons/fa";
import { SiTether } from "react-icons/si";

import usericon from "../assets/img/user.png"

import MetaMask from "../assets/meta-mask.png"
const MyReferralLink = ({ address, isJoined,objUser }) => {

  const [copied, setCopied] = useState(false);

  // ⛔ If Not Joined → Render Nothing
  // if (!isJoined) return null;
    if (!isJoined || !address) return null;


  // ✅ Build Referral Link
  const referralLink = `${window.location.origin}?ref=${address || ""}`;

  // ✅ Copy Handler
  const handleCopy = () => {
    navigator.clipboard.writeText(referralLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset After 2s
    });
  };


  // 🔹 ADD TOKEN TO METAMASK (opBNB Testnet)
  const addTokenToMetaMask = async () => {
    const tokenAddress = "0x9d07dAC32d7c835E9daA1802Ced37e5Fc5F9F2aD"; // ⭐ आपका token address
    const tokenSymbol = "BUSDT";
    const tokenDecimals = 18;
    const tokenImage = "https://bscscan.com/token/images/busdt_32.png"; // ⭐ public folder में रखें

    try {
      const wasAdded = await window.ethereum.request({
        method: "wallet_watchAsset",
        params: {
          type: "ERC20",
          options: {
            address: tokenAddress,
            symbol: tokenSymbol,
            decimals: tokenDecimals,
            image: tokenImage,
          },
        },
      });

      if (wasAdded) {
        alert("Token added successfully!");
      } else {
        alert("Token adding rejected.");
      }
    } catch (error) {
      console.error("MetaMask Error:", error);
      alert("MetaMask error: check console.");
    }
  };

  return (

    <>


      <div className="comunity-div">
        <div className="row">
          <div className="col-md-12">

            <div className="new_joining card-comunity cm-1">
              <div className="card-inner-div">
                <div className="referral_row">
                  <div className="row w-100 align-items-end">
                    <div className="col-md-8">
                      <div className="referral-col">
                        <img src="referral-pic.svg" className="referral-pic-svg" />
                        <div className="referral-input">
                          <div className="section-title">
                            {/* <h2 className="">  <span>My Referral Link</span> </h2> */}
                            <p className="mb-2">
                           Share my referral link with your friends and invite them to join!
                            </p>
                          </div>
                          <div className="input-group bonus_input">
                            <span className="input-group-text">
                              <FaUsers />
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              value={referralLink}
                              readOnly
                            />   <button className="btn btn-success" onClick={handleCopy}>
                              {copied ? <FaCheck /> : <FaCopy />}{" "}
                              {copied ? "Copied!" : "Copy"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className=" col-md-4">
                      {/* ⭐ Add Token to MetaMask Button */}
                      <div className="metamask-row">
                        {/* <button
                          onClick={addTokenToMetaMask}
                          className="btn btn-success btn-sm d-flex align-items-center gap-2"
                        >
                          <SiTether size={22} />
                          Import USDT
                          <img src={MetaMask} alt="" className="metamsk-image" />
                        </button> */}
                          
                          {/* <button className="btn btn-warning" onClick={() =>
                            window.open(
                              "https://opbnb-testnet.bscscan.com/address/0x48E5D374694e2F88973C694F06c5d62ab76809Ff",
                              "_blank",
                              "noopener noreferrer"
                            )
                          }>
                            NFT Contract
                          </button> */}
                     <div className="user-box">
                          <div className="card-body">  
                            <div class=" user-icon">
                              <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 640 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"></path></svg>
                               {/* <img src={usericon} alt="" className="user-icon" /> */}
                               <h5 class="my-user-text">My User ID: </h5>
                                  <div class="stat-value">{objUser.userId ? String(objUser.userId) : "0"} <span class="usdt-tag"></span></div> 
                                  </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>




                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>

  );
};

export default MyReferralLink;
